const UserEndpoints = {
  GET_USER_LIST: "/users/",
  CREATE_USER: "/users/",
  UPDATE_USER: (userId: string) => `/users/${userId}/`,
  DELETE_USER: (userId: string) => `/users/${userId}/`,
};

export default UserEndpoints;
